var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-2" },
    [
      _c(
        "q-btn-group",
        {
          staticClass: "mt-5 flex-column justify-content-center w-100",
          attrs: { outline: "" }
        },
        [
          _c("q-btn", {
            attrs: {
              size: "xl",
              "no-caps": "",
              color: !_vm.active ? "primary" : "",
              label: "All"
            },
            on: {
              click: function($event) {
                _vm.setFilter(null)
              }
            }
          }),
          _vm._l(_vm.categories, function(category, index) {
            return _c("q-btn", {
              key: index + category,
              attrs: {
                size: "xl",
                "no-caps": "",
                color: _vm.active === category ? "primary" : "",
                label: _vm.getCategoryLabel(category)
              },
              on: {
                click: function($event) {
                  _vm.setFilter(category)
                }
              }
            })
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }